// api-config.ts
export const API_CONFIG = {
  accounting: {
    baseUrl: '/nebula-accounting-core/api/v1',
    endpoints: {
      // ... endpoints existentes
      tipoCentroCostos: '/tipo-centro-costos',
      centroCostos: '/centros-costos',
      conceptosContables: '/conceptos-contables',
      parametrosSistema: '/parametros-sistema',
      tiposAsiento: '/tipos-asiento',
      clasificacionesAsiento: '/clasificaciones-asiento',
      tipoAsiento: '/conceptos-contables/tipos-asiento',
      estructuraCuentas: '/estructura-cuentas',
      conceptosDian: '/conceptos-dian',
      tipoPlanContable: '/tipo-plan-contable',
      tipoPlan: '/tipo-plan',
      tipoPlanHistorico: '/tipo-plan-historico',
      planCuentasHistorico: '/plan-cuentas-historico',
      estructuraHistorico: '/estructura-historico',
      dependencia: '/dependencia',
      usuarioDependencia: '/usuario-dependencia',
      monedas: '/monedas',
      tasasCambio: '/monedas/tasas',
      formatosContables: '/formatos-contables',
      terceros: '/terceros',
      planCuentas: '/plan-cuentas-contables',
      homologacionesPlanCuentas: '/homologaciones-cuentas',
      causaciones: '/causaciones',
      articulos: '/articulos',
      ordenesPago: '/ordenes-pago',
      logCausaciones: '/log-causaciones',
      saldosContables: '/saldos-contables',
      saldosContablesFull: '/saldos-contables/full',
      estadosDocumentoCausacion: '/estados-documento-causacion',
      estadosOrdenPago: '/estados-orden-pago',
      diferidos: '/diferidos',
      asientosDiferidos: '/asientos-diferidos',
      depreciaciones: '/depreciaciones',
      asientosContables: '/asientos-contables',
      entidadesBancarias: '/entidades-bancarias',
      causacionesAprobacion: '/causaciones-aprobacion',
      causacionesAnulacion: '/causaciones-anulacion',
      asientosAnulacion: '/asientos-anulacion',
      actividadEconomica: '/actividad-economica',
      cierreContable: '/cierre-contable',
      formatosBanco: '/contabilidad/formatos-banco',
      conciliacionesBancarias: '/contabilidad/conciliaciones-bancarias',
    },
  },
  masters: {
    baseUrl: '/nebula-masters/api/v1',
    endpoints: {
      parametrosSistema: '/',
      paises: '/paises',
      departamentos: '/departamentos',
      ciudades: '/ciudades',
      consecutivos: '/consecutivos',
      consecutivoTipos: '/consecutivos/tipos',
      roles: '/roles',
      triggers: '/trigger',
      permisosOperacion: '/permiso',
      rolPermisos: '/rol-permiso',
      usuariosConPermisos: '/rol-permiso/usuarios-con-permisos',
      tiposMaestro: '/tipos-maestro',
      detallesMaestro: '/tipos-maestro/detalles',
      favoritos: '/favoritos',
      parametrosDefinicion: '/parametros-definicion',
      parametrosPlantilla: '/parametros-plantilla',
      parametrosAsignacion: '/parametros-asignacion',
    },
  },
  treasury: {
    baseUrl: '/nebula-treasury/api/v1',
    endpoints: {
      parametrosSistema: '/parametros-tesoreria',
      embargos: '/embargos',
      cuentasBancarias: '/cuentas-bancarias',
      comprobanteEgreso: '/comprobantes-egreso',
      bancoPagos: '/banco-pagos',
      cuentasBanco: '/banco-pagos/cuentas-banco',
      anulacionIngreso: '/anulacion-ingreso',
      terceroTesoreria: '/terceros-tesoreria',
      cierreOperacionesBancarias: '/cierre-operaciones-bancarias',
      estructurasArchivoPago: '/estructuras-archivo-pago',
    },
  },
  invoicing: {
    baseUrl: '/nebula-invoicing/api/v1',
    endpoints: {
      parametrosSistema: '/parametros-facturacion',
      documentosFacturacion: '/documentos-facturacion',
      tiposDocumento: '/documentos-facturacion/tipos',
      conceptos: '/documentos-facturacion/conceptos',
      conceptosFacturacion: '/conceptos-facturacion',
      facturasSaldo: '/documentos-facturacion/tercero',
      facturasPage: '/documentos-facturacion/page-response',
      tiposDocumentoParametros: '/parametros-facturacion/tipos-documento',
      notas: '/notas',
      notasAprobacion: '/facturacion/notas/aprobacion',
      facturasAprobacion: '/facturacion/aprobacion',
      facturasAnulacion: '/facturacion/anulacion',
      aprobadores: '/documentos-facturacion/aprobadores',
      cierreFacturacion: '/cierre-facturacion',
    },
  },
  budget: {
    baseUrl: '/nebula-budget-core/api/v1',
    endpoints: {
      cuipos: '/presupuesto/parametros/page-response-cuipo',
      parametrosSistema: '/presupuesto/parametros',
      fuentesFinanciacion: '/presupuesto/fuentes-financiacion',
      proyectos: '/presupuesto/proyectos',
      tiposRecurso: '/presupuesto/tipos-recurso',
      aprobacionApropiaciones: '/presupuesto/aprobacion-apropiaciones',
      anulacionApropiaciones: '/presupuesto/anulacion-apropiaciones',
      rubros: '/presupuesto/rubros',
      catalogoRubros: '/presupuesto/catalogo-rubros',
      estructurasRubro: '/presupuesto/estructuras-rubro',
      cierrePresupuestal: '/cierre-presupuestal',
      apropiacionInicial: '/presupuesto/apropiaciones-iniciales',
      vigenciasFuturas: '/presupuesto/vigencias-futuras',
      modificacionesPresupuestales: '/presupuesto/modificaciones-presupuestales',
      aprobacionModificaciones: '/presupuesto/aprobacion-modificaciones',
      anulacionModificaciones: '/presupuesto/anulacion-modificaciones',
    },
  },
  budgetExecution: {
    baseUrl: '/nebula-budget-execution/api/v1',
    endpoints: {
      parametrosSistema: '/presupuesto/parametros',
      disponibilidades: '/presupuesto/disponibilidades',
      aprobacionDisponibilidades: '/presupuesto/aprobacion-disponibilidades',
      anulacionDisponibilidades: '/presupuesto/anulacion-disponibilidades',
      registrosPresupuestales: '/presupuesto/registros-presupuestales',
      aprobacionRegistrosPresupuestales: '/presupuesto/aprobacion-registros-presupuestales',
      liberacionRegistrosPresupuestales: '/presupuesto/liberacion-registros-presupuestales',
      saldosRubros: '/presupuesto/saldos-rubros',
      anticipos: '/presupuesto/anticipos',
      aprobacionAnticipos: '/presupuesto/aprobacion-anticipos',
      anulacionAnticipos: '/presupuesto/anulacion-anticipos',
    },
  },
} as const;
